// extracted by mini-css-extract-plugin
export var recomCardContainer = "RecommendationCard-module--recomCardContainer--1vTYE";
export var recomCardTitle = "RecommendationCard-module--recomCardTitle--10W8b";
export var contentBody = "RecommendationCard-module--contentBody--3BA-u";